import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { ResponsiveImage } from './ResponsiveImage';

export function ItemImageComponent(props) {
    const {
        photoIndex,
        item, // eslint-disable-line no-unused-vars
        relay, // eslint-disable-line no-unused-vars
        ...otherProps
    } = props;
    const photo = props.item.photos[photoIndex];

    return <ResponsiveImage {...otherProps} photo={photo} />;
}

ItemImageComponent.propTypes = {
    item: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    isClient: PropTypes.bool.isRequired,
    photoIndex: PropTypes.number,
};

ItemImageComponent.defaultProps = {
    photoIndex: 0,
};

export const ItemImage = createFragmentContainer(ItemImageComponent, {
    item: graphql`
        fragment ItemImage_item on Item {
            photos(limit: 1, skipImageService: true) {
                largePath
                masterOrZoomPath
            }
        }
    `,
});
